import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@lohi/environments/environment';
import { map } from 'rxjs/operators';

export interface FFShifts {
  ffShiftCalendar: FfShiftCalendar;
}

export interface FfShiftCalendar {
  FFDriverShiftPredictionBlocks?: FFDriverShiftPredictionBlocksEntity[] | null;
  RegionID: number;
}

export interface FFDriverShiftPredictionBlocksEntity {
  Date: string;
  DriverGroups?: DriverGroupsEntity[] | null;
  EndHourOfDay: number;
  StartHourOfDay: number;
}

export interface DriverGroupsEntity {
  Description: string;
  Drivers?: DriversEntity[] | null;
  Name: string;
  Status: string;
}

export interface DriversEntity {
  Name: string;
  PhoneNumber: string;
}

@Injectable({
  providedIn: 'root',
})
export class FfShiftService {
  constructor(private httpClient: HttpClient) {}

  public getShiftData(regionID: number, start: string) {
    return this.httpClient
      .get<FFShifts>(`${environment.api}/v1/internal/ff_future_driver_shift_predictions/${regionID}?date=${start}`)
      .pipe(
        map((value) => {
          value.ffShiftCalendar.FFDriverShiftPredictionBlocks.forEach((value1) =>
            value1.DriverGroups.forEach(
              (value2) => (value2.Drivers = value2.Drivers?.sort((a, b) => a.Name.localeCompare(b.Name))),
            ),
          );
          return value;
        }),
      );
  }
}
